module.exports = __webpack_public_path__ + "img/process-icon.63882de7.svg";